import axios from 'axios';

import { toast } from 'react-toastify';

import api from '@api';

export const loginUserByEmailAndPassword = async (
  loginForm,
  axiosInstance = api,
) => {
  try {
    // const response = await axiosInstance.post('/auth/login', loginForm);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/admin/login`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginForm),
        credentials: 'include',
      },
    );
    const content = await response.json();

    return {
      status: response.status,
      data: content || { message: content },
    };
  } catch (error) {
    return {
      data: { message: error.message },
    };
  }
};

export const getUserProfileById = async (token, id, axiosInstance = api) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // const response = await axiosInstance.get(`/admin/get-admins/${id}`, config);

    const response = await axiosInstance.get(`/admin/get-admins`, config);

    return response;
  } catch (error) {
    if (error.name === 'AxiosError') {
      return {
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
      };
    }

    console.log(error);
    return error;
  }
};

const url = process.env.REACT_APP_API_URL;

export const handleDeleteAccount = async (id, idToken, setDeleteStatus) => {
  try {
    const response = await axios.delete(`${url}/admin/delete-user/${id}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'My-Custom-Header': 'foobar',
      },
    });
    console.log(response);
    if (setDeleteStatus) setDeleteStatus('Delete successful');
    toast.success('Account has been deleted successfully', {
      autoClose: 2000,
      position: 'top-center',
    });
  } catch (error) {
    console.error(error);
    toast.error('Failed to delete account', {
      autoClose: 2000,
      position: 'top-center',
    });
  }
};
